<template>
  <div class="w-100">
    <transition name="fade">
      <div class="position-relative z-index-1045">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-bottom d-block nav-bottom" style="top:23%">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-xl-4 col-lg-5 col-md-5 col-sm-8 col-12 position-relative">
                  <div class="bg-white mx-5 rounded-6">
                    <div class="w-100 py-4 px-2">
                      <div class="container px-4 text-center position-relative">
                        <div class="mb-3 mx-auto">
                          <div class="mx-auto">
                            <img src="../../../assets/img/icon/404.png" width="180">
                          </div>
                        </div>
                        <div class="pb-3">
                          <template v-if="data !=''">
                            <template v-if="data == 'redirect to payment'">
                              <p class="mb-0 body-2-2 text-20 font-extrabold">{{$t("hotel.error.redirect-to-payment")}}</p>
                            </template>
                            <template v-else-if="data == 'payment-pending'">
                              <p class="mb-0 body-2-2 text-20 font-extrabold">Please wait, the payment is still being processed</p>
                            </template>
                            <template v-else-if="data == 'invalid tx id'">
                              <p class="mb-0 body-2-2 text-20 font-extrabold">{{$t("hotel.error.invalid-email-address")}}</p>
                              <p class="mb-0 body-2-2 font-regular text-14">{{$t("hotel.error.invalid-email-address-desc")}}</p>
                            </template>
                            <template v-else-if="data == 'invalid check_in_date'">
                              <p class="mb-0 body-2-2 text-20 font-extrabold">{{$t("hotel.error.invalid check_in_date")}}</p>
                              <p class="mb-0 body-2-2 font-regular text-14">{{$t("hotel.Please choose another date")}}</p>
                            </template>
                            <template v-else-if="data == 'room not available'">
                              <p class="mb-0 body-2-2 text-20 font-extrabold">{{$t("hotel.error.room not available")}}</p>
                              <p class="mb-0 body-2-2 font-regular text-14">{{$t("hotel.please-choose-another-room")}}</p>
                            </template>
                            <template v-else>
                              <p class="mb-0 body-2-2 text-20 font-extrabold">{{data}}</p>
                            </template>
                          </template>
                          <template v-else>
                            <p class="mb-0 body-2-2 text-20 font-extrabold">{{$t("hotel.no-room-selected")}}</p>
                            <p class="mb-0 body-2-2 font-regular text-14">{{$t("hotel.please-select-the-room-to-be-booked")}}</p>
                          </template>
                          <div 
                            v-if="data == ''">
                            <button type="button" class="button-primary py-2 px-3 text-12 mt-3" @click="redirectReset()">{{$t("hotel.book-rooms")}}</button>
                          </div>
                          <router-link 
                            v-else-if="data == 'invalid check_in_date'" :to="'/'+getMerchant().code+'/booking'">
                            <button type="button" class="button-primary py-2 px-3 text-12 mt-3">{{$t("hotel.choose-another-date")}}</button>
                          </router-link>
                          <button type="button" class="button-primary py-2 px-3 text-12 mt-3" v-else-if="data == 'invalid tx id'" @click="reloadPage()">{{$t("hotel.error.confirm-again")}}</button>
                          <button type="button" class="button-primary py-2 px-3 text-12 mt-3" v-else @click="clsoePopup()">{{$t("hotel.action.close")}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
  export default{
    props:['data'],
    methods: {
      ...mapGetters(['getMerchant']),
      ...mapMutations(['resetBECart']),
      reloadPage(){
        location.reload()
      },
      redirectReset(){
        this.resetBECart()
        this.$router.push({
          path: '/'+this.getMerchant().code+'/booking'
        })
      },
      clsoePopup(){
        this.$emit('close')
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/PopUpWarning.vue